import {v4} from "uuid"
export class Base64Tools {
    static parse(uuid: string): Uint8Array {
        let v;
        const arr = new Uint8Array(16); // Parse ########-....-....-....-............

        arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24;
        arr[1] = v >>> 16 & 0xff;
        arr[2] = v >>> 8 & 0xff;
        arr[3] = v & 0xff; // Parse ........-####-....-....-............

        arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8;
        arr[5] = v & 0xff; // Parse ........-....-####-....-............

        arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8;
        arr[7] = v & 0xff; // Parse ........-....-....-####-............

        arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8;
        arr[9] = v & 0xff; // Parse ........-....-....-....-############
        // (Use "/" to avoid 32-bit truncation when bit-shifting high-order bytes)

        arr[10] = (v = parseInt(uuid.slice(24, 36), 16)) / 0x10000000000 & 0xff;
        arr[11] = v / 0x100000000 & 0xff;
        arr[12] = v >>> 24 & 0xff;
        arr[13] = v >>> 16 & 0xff;
        arr[14] = v >>> 8 & 0xff;
        arr[15] = v & 0xff;
        return arr;
    }

    static Base64FromRandomUint64(): string {
        const uuid = crypto.randomUUID ? crypto.randomUUID() : v4()
        const bytes = Base64Tools.parse(uuid)
        const a = bytes.slice(0, 8)
        const b = bytes.slice(8, 16)
        const b64 = Uint8Array.from(a, (v, i) => v ^ b[i])
        return btoa(String.fromCharCode(...b64))
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .substring(0, 11)
    }
}
